import { Box, Flex } from '@chakra-ui/react';
import { EVMGasPaymentMethod } from '@halo/wallet-app';
import React from 'react';
import { DrawerPanel } from './drawer-panel';
import SelectedIcon from './images/selected.svg?react';
import SelectDownIcon from './images/select-down.svg?react';

interface PaymentMethodSelectorProps {
  value: EVMGasPaymentMethod | undefined;
  onChange: (evmPaymentMethod: EVMGasPaymentMethod) => void;
  container?: React.RefObject<HTMLDivElement | null>;
}

const PaymentMethods = [EVMGasPaymentMethod.EIP1559, EVMGasPaymentMethod.BID];

export function PaymentMethodSelector({
  value,
  onChange,
  container,
}: PaymentMethodSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);

  const onChangeRef = useRef(onChange);

  onChangeRef.current = onChange;

  const handleChange = useCallback((evmPaymentMethod: EVMGasPaymentMethod) => {
    onChangeRef.current(evmPaymentMethod);
    setIsOpen(false);
  }, []);

  useLayoutEffect(() => {
    if (!value) {
      onChangeRef.current(PaymentMethods[0]);
    }
  }, [value]);

  return (
    <>
      <Flex
        alignItems="center"
        gap="1"
        fontSize="xs"
        fontWeight="medium"
        cursor="pointer"
        onClick={() => setIsOpen(true)}
      >
        <Box>{value}</Box>
        <SelectDownIcon />
      </Flex>
      <PaymentMethodSelectorPanel
        value={value}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onChange={handleChange}
        container={container}
      />
    </>
  );
}

interface PaymentMethodSelectorPanelProps {
  value: EVMGasPaymentMethod | undefined;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onChange: (evmPaymentMethod: EVMGasPaymentMethod) => void;
  container?: React.RefObject<HTMLDivElement | null>;
}

export function PaymentMethodSelectorPanel({
  container,
  value,
  isOpen,
  setIsOpen,
  onChange,
}: PaymentMethodSelectorPanelProps) {
  return (
    <DrawerPanel
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      container={container}
      title={
        <Flex
          flex="1"
          alignItems="center"
          justifyContent="center"
          fontSize="md"
          fontWeight="bold"
          ml="-20px"
        >
          Select the payment method
        </Flex>
      }
    >
      <Box px="1.5">
        {PaymentMethods.map((method) => (
          <Flex
            key={method}
            alignItems="center"
            justifyContent="space-between"
            gap="2.5"
            py="4"
            cursor="pointer"
            onClick={() => onChange(method)}
          >
            <Box fontSize="md" fontWeight="medium">
              {method}
            </Box>
            {value === method && <SelectedIcon />}
          </Flex>
        ))}
      </Box>
    </DrawerPanel>
  );
}
